<div class='previewModal'>
    <div class="modal-header">
        <h4 class="modal-title roboTitle" id="modal-basic-title">{{'invoices.modalEsito.title' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="close()">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ng-container>
            <div class="form-group">
              <label class="roboSubTitle" for="address">{{'invoices.modalEsito.custom' | translate}}</label>
              <input type="text" class="form-control" id="address" placeholder="{{'invoices.modalEsito.custom' | translate}}" [(ngModel)]="motivoEsito">
          </div>
        </ng-container>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-dark" (click)="close()">{{ 'general.close' | translate }}</button>
        <button type="button" class="btn btn-success" (click)="esitaFattura(1)">{{ 'invoices.modalEsito.accept' | translate }}</button>
        <button type="button" class="btn btn-danger" (click)="esitaFattura(0)">{{ 'invoices.modalEsito.refuse' | translate }}</button>
    </div>
</div>
